import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdContrato: number;
  IdContratoArquivo: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setIdContrato: SetFunction<number>;
  setIdContratoArquivo: SetFunction<number>;
};

export const initialFiltersValues: State = {
  IdContrato: 0,
  IdContratoArquivo: 0,
};

export const useContratoArquivoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setIdContrato: (vfn) => SetFunctionImpl(set, 'IdContrato', vfn),
  setIdContratoArquivo: (vfn) => SetFunctionImpl(set, 'IdContratoArquivo', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));